import React, { Component } from 'react';
import TopLists from "./TopLists";
import ViewState from "./ViewState";

class CoinTopList extends Component {

    componentDidMount() {
        this.props.appState.viewState = ViewState.table;
        let appState = this.props.appState;
        appState.updateCoins()
    }

    componentWillUpdate() {
        document.title = "CoinGrasp Top Lists";
    }

    render() {
        return (
            <div className="cg-coin-list">
                <div className="top-list-container col-lg-12">
                    <TopLists amount={10} { ...this.props} />
                </div>
            </div>
        );
    }
}

export default CoinTopList;



// WEBPACK FOOTER //
// ./src/CoinTopList.js